import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "subheader-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "subheader-icon fal fa-users" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-xl-12" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = { class: "panel-hdr mt-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plus-square" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-sm-block float-right ml-1" }, "Nuevo", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "fw-300" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-collapse",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Collapse"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-fullscreen",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Fullscreen"
  })
], -1)
const _hoisted_14 = { class: "panel-container" }
const _hoisted_15 = { class: "panel-content" }
const _hoisted_16 = { class: "row mb-1" }
const _hoisted_17 = { class: "col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "fecha_venta"
}, "Fecha", -1)
const _hoisted_20 = { class: "input-group" }
const _hoisted_21 = ["onKeyup"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" }, null, -1)
const _hoisted_23 = { class: "col-xl-12" }
const _hoisted_24 = {
  id: "panel-listado",
  class: "panel"
}
const _hoisted_25 = { class: "panel-hdr mt-2" }
const _hoisted_26 = { class: "fw-300" }
const _hoisted_27 = {
  class: "ml-3 text-danger font-weight-bold font-italic",
  style: {"font-size":"18px"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-collapse",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Collapse"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-panel",
    "data-action": "panel-fullscreen",
    "data-toggle": "tooltip",
    "data-offset": "0,10",
    "data-original-title": "Fullscreen"
  })
], -1)
const _hoisted_29 = { class: "panel-container" }
const _hoisted_30 = { class: "panel-content" }
const _hoisted_31 = { class: "row mb-2" }
const _hoisted_32 = { class: "col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "input-group" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" })
  ])
], -1)
const _hoisted_36 = { class: "text-right" }
const _hoisted_37 = { class: "custom-control custom-checkbox ml-3" }
const _hoisted_38 = ["id", "name", "checked"]
const _hoisted_39 = ["for"]
const _hoisted_40 = { class: "input-group-append" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-print" }, null, -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", {
  class: "page-content-overlay",
  "data-action": "toggle",
  "data-class": "mobile-nav-on"
}, null, -1)

import { onMounted, ref, } from 'vue'; 
import { useRouter } from 'vue-router';
import numeral from 'numeral';
import useVentas from '../composables/useVentas';
import jsPDF from 'jspdf';


export default /*#__PURE__*/_defineComponent({
  __name: 'VentasAdminView',
  setup(__props) {

const router = useRouter();
const {
    obtenerVentasPorFecha,
} = useVentas();

const totalVentas = ref<any>(0);
const totalProductos = ref<any>(0);

const hoy = new Date();
const fitroBusqueda = ref<any>({
    textoBuscar: hoy.getFullYear().toString()
        + '-' + ((hoy.getMonth() + 1) < 10 ? '0' + (hoy.getMonth() + 1).toString() : (hoy.getMonth() + 1).toString())
        + '-' + (hoy.getDate() < 10 ? '0' + hoy.getDate().toString() : hoy.getDate().toString())
});

const headers = [
    { text: 'Fecha', value: 'fecha_venta', sortable: true },
    { text: 'Tipo Pago', value: 'nombre_tipo_pago', sortable: true },
    { text: 'Producto', value: 'nombre_producto', sortable: true },
    { text: 'Cantidad', value: 'cantidad', sortable: true },
    { text: 'Precio Unitario', value: 'precio_unitario', sortable: true },
    { text: 'Descuento', value: 'descuento', sortable: true },
    { text: 'Total', value: 'importe', sortable: true },
    { text: 'Estado', value: 'estado', sortable: true },
    { text: 'Imprimir', value: 'imprimir', sortable: true },
];

let ventas: any = [];
const ventasFiltrados = ref<any[]>([]);

const textoFiltro = ref<string>('');

onMounted(async() => {
    await buscarVentas();
});

const buscarVentas = async () => {
    textoFiltro.value = '';
    const resp = await obtenerVentasPorFecha(fitroBusqueda.value.textoBuscar);
    if (resp.ok) {
        ventas = resp.data;
        ventasFiltrados.value = JSON.parse(JSON.stringify(ventas));

        calcularTotalVentas();
    }
}

const calcularTotalVentas = async() => {
    totalVentas.value = 0;
    totalProductos.value = 0;
    ventasFiltrados.value.forEach((venta: any) => {
        totalVentas.value += Number(venta.importe);
        totalProductos.value+= Number(venta.cantidad);
    });
}

const nuevaVenta = async () => {
    router.push({ name: 'ventas-editar' });
}

const filtrarInformacion = async () => {
    ventasFiltrados.value = JSON.parse(JSON.stringify(
        ventas.filter(
            (u: any) => u.nombre_producto.toLowerCase().includes(textoFiltro.value.toLowerCase())
                || u.nombre_cliente.toLowerCase().includes(textoFiltro.value.toLowerCase())
                || u.fecha_venta.toLowerCase().includes(textoFiltro.value.toLowerCase())
                || u.nombre_tipo_pago.toLowerCase().includes(textoFiltro.value.toLowerCase())
                || u.importe.toLowerCase().includes(textoFiltro.value.toLowerCase())
        )
    ));

    calcularTotalVentas();
}

const imprimirVenta = async (item: any) => {
    
    const pdf = new jsPDF("p", "mm", "letter");
    pdf.setFontSize(9);

    pdf.setFont("helvetica", "bold");
    pdf.text('DETALLE DE PRODUCTOS',85,18);

    pdf.setFont("helvetica", "normal");
    pdf.text('CLIENTE:', 15, 25);
    pdf.setFont("helvetica", "bold");
    pdf.text(String(item.nombre_cliente), 42, 25);
    pdf.setFont("helvetica", "normal");
    pdf.text('FECHA | HORA DE VENTA:', 123, 25);
    pdf.setFont("helvetica", "bold");
    pdf.text(String(item.fecha_venta), 167, 25);

    pdf.setFont("helvetica", "normal");
    pdf.text('TIPO DE PAGO:', 15, 30);
    pdf.setFont("helvetica", "bold");
    pdf.text(String(item.nombre_tipo_pago), 42, 30);
    
    pdf.output("dataurlnewwindow", { filename: "Detalle-Venta" });
}

return (_ctx: any,_cache: any) => {
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", { class: "float-left" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary btn-sm mr-2",
                  title: "Nuevo",
                  onClick: nuevaVenta
                }, _hoisted_11)
              ]),
              _createElementVNode("h2", null, [
                _createTextVNode(" Filtro de"),
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
                ])
              ]),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          id: "fecha_venta",
                          name: "fecha_venta",
                          class: "form-control form-control-sm",
                          placeholder: "Fecha de venta",
                          autocomplete: "off",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fitroBusqueda.value.textoBuscar) = $event)),
                          onKeyup: _withKeys(buscarVentas, ["enter"])
                        }, null, 40, _hoisted_21), [
                          [
                            _vModelText,
                            fitroBusqueda.value.textoBuscar,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("div", { class: "input-group-append" }, [
                          _createElementVNode("button", {
                            class: "btn btn-primary btn-sm mb-2",
                            id: "btn-buscar-ventas",
                            name: "btn-buscar-ventas",
                            type: "button",
                            onClick: buscarVentas
                          }, [
                            _hoisted_22,
                            _createTextVNode(" Buscar ")
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("h2", null, [
                _createTextVNode(" Listado de"),
                _createElementVNode("span", _hoisted_26, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$router.currentRoute.value.meta.titleForm), 1)
                ]),
                _createElementVNode("span", _hoisted_27, _toDisplayString(`Total general: Bs. ${ _unref(numeral)(totalVentas.value).format('0,0.00') }.- | Total productos: ${ _unref(numeral)(totalProductos.value).format('0') }.-`), 1)
              ]),
              _hoisted_28
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "texto-buscar",
                          name: "texto-buscar",
                          class: "form-control form-control-sm flex",
                          placeholder: "Buscar",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((textoFiltro).value = $event)),
                          onInput: filtrarInformacion
                        }, null, 544), [
                          [_vModelText, textoFiltro.value]
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_EasyDataTable, {
                  headers: headers,
                  items: ventasFiltrados.value,
                  "border-cell": "",
                  alternating: "",
                  "buttons-pagination": ""
                }, {
                  "item-importe": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(numeral)(item.importe).format('0,0.00')), 1)
                  ]),
                  "item-estado": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "custom-control-input",
                        id: 'estado' + item.id_cliente,
                        name: 'estado' + item.id_cliente,
                        checked: item.estado
                      }, null, 8, _hoisted_38),
                      _createElementVNode("label", {
                        class: "custom-control-label",
                        for: 'estado_' + item.id_cliente
                      }, null, 8, _hoisted_39)
                    ])
                  ]),
                  "item-imprimir": _withCtx((item) => [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary btn-xs",
                        title: "Imprimir Venta",
                        onClick: ($event: any) => (imprimirVenta(item))
                      }, _hoisted_43, 8, _hoisted_41)
                    ])
                  ]),
                  _: 1
                }, 8, ["items"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _hoisted_44
  ], 64))
}
}

})